import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=69b7e5ba&scoped=true&"
import script from "./CoursePage.vue?vue&type=script&lang=js&"
export * from "./CoursePage.vue?vue&type=script&lang=js&"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=69b7e5ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7e5ba",
  null
  
)

export default component.exports